import { createFileRoute } from '@tanstack/react-router'
import { ContractsSection } from '../../../features/settings/contracts-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/contracts')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'contracts'),
  component: ContractsSection,
})
